module.exports = __webpack_public_path__ + "static/media/1.fbff4784.jpg";